import React, { useCallback, useContext, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import message from 'antd/lib/message';
import { useQuery } from 'react-query';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';
import { FirebaseContext } from '../../../context/FirebaseContext';
import { useTheme } from '../../../context/ThemeContext.js.js';
import Button from '../../../NecttosComp/Button/Button';
import { getAditionalStatiData } from '../../../NecttosComp/APICaller/ApiServices';
import { Body, Header, Main } from '../../../NecttosComp/Layout/Layout';
import Input2 from '../../../NecttosComp/Input/Input2';

function NewQuestionnaire({ onSuccess, itemData, onCloseModal, questionnaireId, refectOrgin }) {
	const { collegeId } = useContext(FirebaseContext);
	const { theme } = useTheme();
	const [state, setState] = useState(itemData || {});
	const [data, setData] = useState({});

	const { data: getAditionalStati = {} } = useQuery(['getAditionalStatiData', data], getAditionalStatiData({ collegeId, collection: 'users', stateData: state }));

	const manageDDCSubject = useCallback(async () => {
		let selectedClassArray = [];
		let catogoryDatas = Object.keys(state).map((key) => ({
			type: String(key).slice(0, 2),
			category: String(key).slice(2),
			value: state[key],
		}));

		catogoryDatas.forEach((item) => {
			if (item.type === '~l' && item.value) {
				selectedClassArray.push(item.category);
			}
		});

		try {
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/iqac/postQuestionnair', {
				collegeId,
				title: state.title,
				effectFrom: state.effectFrom,
				type: state.type,
				from: state.from,
				mode: state.mode,
				semester: state.semester,
				academicYear: state.academicYear,
				nature: state.nature,
				lastDate: state.lastDate,
				_id: questionnaireId,
				whoFill: selectedClassArray,
			});

			if (resp.data.statusCode !== 200) throw new Error(resp.data.message || 'API Error');

			refectOrgin();
			onSuccess();
			setState({});
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			onSuccess();
		}
	}, [state, collegeId, questionnaireId, refectOrgin, onSuccess]);

	const sectionStyle = `rounded-2xl shadow-lg p-4 sm:p-6 space-y-6 ${theme === 'dark' ? 'bg-slate-700 border border-slate-600 text-white' : 'bg-white border border-gray-200 text-gray-800'}`;

	return (
		<Main title='New Questionnaire' height='100%' width='100%'>
			<Header>
				<div className='w-full'>
					<div className='flex flex-col sm:flex-row justify-end items-start sm:items-center gap-3'>
						<Button type='save' className='w-full sm:w-auto' onClick={manageDDCSubject}>
							Save
						</Button>
						<Button type='close' className='w-full sm:w-auto' onClick={onCloseModal}>
							Close
						</Button>
					</div>
				</div>
			</Header>

			<Body height='100%'>
				<Scrollbars className='h-full'>
					<div className='max-w-7xl mx-auto p-4 sm:p-6 space-y-10'>
						<section className={sectionStyle}>
							<h3 className='text-xl font-semibold border-b pb-4 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 '>Basic Information</h3>

							<Input2 type='text' fieldName='Title of Questionnaire*' returnKey='title' state={state} setState={setState} className='w-full' />
							<div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
								<Input2 type='date' fieldName='Effective From*' returnKey='effectFrom' state={state} setState={setState} className='w-full' />
								<Input2
									type='drop'
									fieldName='Category*'
									returnKey='type'
									state={state}
									setState={setState}
									options={[
										{ label: 'Student', value: 'Student' },
										{ label: 'Teacher', value: 'Teacher' },
										{ label: 'Staff', value: 'Staff' },
									]}
									optionDisplay='label'
									optionKey='value'
									className='w-full '
								/>
							</div>
						</section>

						{['Student', 'Teacher', 'Staff'].includes(state?.type) && (
							<section className={sectionStyle}>
								<h3 className='text-xl font-semibold border-b pb-2 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600'>Questionnaire Details</h3>

								<div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
									<Input2
										type='drop'
										fieldName='Mode of Questionnaire*'
										returnKey='mode'
										state={state}
										setState={setState}
										options={[
											{ label: 'Teacher Evaluation', value: 'Teacher Evaluation' },
											{ label: 'Subject Evaluation', value: 'Subject Evaluation' },
											{ label: 'Subject and Teacher Evaluation', value: 'Subject and Teacher Evaluation' },
											{ label: 'General Evaluation', value: 'General Evaluation' },
										]}
										optionDisplay='label'
										optionKey='value'
										className='w-full text-black-900 '
									/>

									<Input2
										type='drop'
										fieldName='Nature of Questionnaire*'
										returnKey='nature'
										state={state}
										setState={setState}
										options={[
											{ label: 'Very Important', value: 'Very Important' },
											{ label: 'Important', value: 'Important' },
											{ label: 'Partially Important', value: 'Partially Important' },
											{ label: 'Normal', value: 'Normal' },
										]}
										optionDisplay='label'
										optionKey='value'
										className='w-full '
									/>

									{['Teacher Evaluation', 'Subject Evaluation', 'Subject and Teacher Evaluation'].includes(state?.mode) && (
										<>
											<Input2
												type='drop'
												fieldName='Mode Of semester*'
												returnKey='semester'
												state={state}
												setState={setState}
												options={[
													{ label: 'Odd Semester [1,3,5]', value: 'Odd Semester [1,3,5]' },
													{ label: 'Even Semester [2,4,6]', value: 'Even Semester [2,4,6]' },
												]}
												optionDisplay='label'
												optionKey='value'
												className='w-full'
											/>
											<Input2
												type='drop'
												fieldName='Academic Year*'
												returnKey='academicYear'
												state={state}
												setState={setState}
												options={[
													{ label: '2021-2022', value: '2021-2022' },
													{ label: '2022-2023', value: '2022-2023' },
													{ label: '2023-2024', value: '2023-2024' },
													{ label: '2024-2025', value: '2024-2025' },
													{ label: '2025-2026', value: '2025-2026' },
												]}
												optionDisplay='label'
												optionKey='value'
												className='w-full'
											/>
										</>
									)}

									<Input2 type='date' fieldName='Last Date to Fill*' returnKey='lastDate' state={state} setState={setState} className='w-full' />
								</div>
							</section>
						)}
					</div>
				</Scrollbars>
			</Body>
		</Main>
	);
}

export default NewQuestionnaire;
